"use strict";

exports.__esModule = true;
var _Toolbar = require("./Toolbar");
Object.keys(_Toolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Toolbar[key]) return;
  exports[key] = _Toolbar[key];
});